import { Teleport, computed, defineComponent, onMounted, onUnmounted, ref } from 'vue'

import useToast from '@/composables/feedback/useToast'

import CommonToast from './CommonToast'

export default defineComponent(() => {
  const { toasts, checkToastsTimeout } = useToast()
  const timeout = ref<NodeJS.Timeout | null>(null)

  // #region Getters

  const mappedToasts = computed((): Array<JSX.Element | null> => {
    return toasts.value.map((toast, index) => {
      switch (toast.type) {
        case 'common':
          return (
            <CommonToast
              key={`toast-${index}`}
              item={toast}
            />
          )

        default:
          return null
      }
    })
  })

  // #endregion

  onMounted(() => {
    timeout.value = setInterval(() => {
      checkToastsTimeout()
    }, 1000)
  })

  onUnmounted(() => {
    if (timeout.value !== null) {
      clearInterval(timeout.value)
    }
  })

  return () => (
    <Teleport to='body'>
      <div class='pointer-events-none fixed inset-0 z-9999 h-svh w-screen'>
        <div class='pointer-events-none z-9999 flex h-svh items-end justify-center'>
          <div class='space-y-2 pb-12'>
            {mappedToasts.value}
          </div>
        </div>
      </div>
    </Teleport>
  )
}, {
  name: 'VToast'
})
